import * as clientErrorTypes from 'config/clientErrorTypes';

/**
 * getFormDataApi 可預期的 MESSAGE
 * @typedef {Object} GET_FORM_ANSWER_API_RESPONSE
 * @property {function} NOT_FOUND - 查無資料 (404)
 * @property {function} GET_API_ERROR - API 錯誤 (非 200)
 * @property {function} FORM_DATA_WINNER_NOT_FOUND - 表單得獎者資料錯誤 (422)
 * @see https://app.clickup.com/t/86eteaypg
 */
export const GET_FORM_ANSWER_API_RESPONSE = {
    [clientErrorTypes.FORM_DATA_WINNER_NOT_FOUND]: resp =>
        resp.httpStatus === 422 &&
        ((resp.payload?.message === '2-1022-0301-22' &&
            resp.payload?.errors?.message === 'entryUuid or winnerUuid is required') ||
            (resp.payload?.message === '2-1022-0301-21' &&
                resp.payload?.errors?.message === 'winner not found') ||
            (resp.payload?.message === '2-1022-0301-21' &&
                resp.payload?.errors?.message === 'winner form id not match') ||
            (resp.payload?.message === '2-1022-0301-21' &&
                resp.payload?.errors?.message === 'winner answer not found')),
    [clientErrorTypes.NOT_FOUND]: resp => resp.httpStatus === 404,
    [clientErrorTypes.GET_API_ERROR]: resp => resp.httpStatus !== 200
};
